import React from "react";
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

const responsive = {
    0: { items: 1 },
    568: { items: 3 },
    1024: { items: 6 },
};


const MultipleCarousel = ({ items }) => {
    return (
        <AliceCarousel
            autoPlay
            autoPlayStrategy="none"
            autoPlayInterval={1500}
            animationDuration={750}
            animationType="fadeout"
            infinite
            touchTracking={false}
            responsive={responsive}
            items={items}
            disableDotsControls
            mouseTracking />
    )
}

export default MultipleCarousel
